import { createEntityAdapter, EntityState } from '@ngrx/entity'
import { createReducer, on } from '@ngrx/store'
import { PromoText } from '@tradecafe/types/core'
import { DeepReadonly } from '@tradecafe/types/utils'
import * as PromoTextActions from './promo-text.actions'

export const promoTextsFeatureKey = 'promoTexts'
export interface PromoTextsState extends EntityState<DeepReadonly<PromoText>> {
}

export const selectId = (promoText: DeepReadonly<PromoText>) => promoText.promo_text_id
export const adapter = createEntityAdapter<DeepReadonly<PromoText>>({ selectId })

const initialState: PromoTextsState = adapter.getInitialState({
})

export const promoTextsReducer = createReducer(
  initialState,
  on(PromoTextActions.loadPromoTextsSuccess,
    (state, action) =>
      adapter.setAll(action.promoTexts, state)),
  on(PromoTextActions.createPromoTextSuccess,
    (state, action) =>
      adapter.upsertOne(action.promoText, state)),
  on(PromoTextActions.updatePromoTextSuccess,
    (state, action) =>
      adapter.upsertOne(action.promoText, state)),
  on(PromoTextActions.archivePromoTextSuccess,
    (state, action) =>
      adapter.removeOne(action.id, state)),
)